var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useCallback } from "react";
import { FlyToInterpolator } from "react-map-gl";
import { fitMarkersOnMap, filterFarmersOnNewViewport, getEdgesCoordinates, } from "../../helpers/map";
var useMapCoordinates = function (_a) {
    var farmers = _a.farmers, setFarmers = _a.setFarmers, isMobile = _a.isMobile, coordinatesBounds = _a.coordinatesBounds;
    var _b = useState({}), viewport = _b[0], setViewport = _b[1];
    var _c = useState({}), baseViewport = _c[0], setBaseViewport = _c[1];
    var _d = useState([]), maxBounds = _d[0], setMaxBounds = _d[1];
    var onViewportChange = function (viewState) {
        setViewport(viewState);
    };
    var handleZoom = function (coordinates, zoom) {
        if (zoom === void 0) { zoom = 24; }
        setViewport(__assign(__assign({}, viewport), { latitude: coordinates[0], longitude: coordinates[1], zoom: zoom, transitionDuration: 1000, transitionInterpolator: new FlyToInterpolator({ speed: 2 }) }));
    };
    var resetMap = function () {
        var _a = getEdgesCoordinates(baseViewport), southWest = _a.southWest, northEast = _a.northEast;
        setFarmers(filterFarmersOnNewViewport(farmers, southWest, northEast));
        setViewport(baseViewport);
    };
    var mapRef = useCallback(function (container) {
        if (container !== null) {
            var _a = container.getBoundingClientRect(), width = _a.width, height = _a.height;
            var viewport_1 = fitMarkersOnMap(width, height, isMobile, coordinatesBounds);
            setViewport(viewport_1);
            setBaseViewport(viewport_1);
            var _b = getEdgesCoordinates(viewport_1), southWest = _b.southWest, northEast = _b.northEast;
            setMaxBounds([southWest, northEast]);
        }
    }, [coordinatesBounds, isMobile]);
    return {
        mapRef: mapRef,
        viewport: viewport,
        onViewportChange: onViewportChange,
        handleZoom: handleZoom,
        resetMap: resetMap,
    };
};
export default useMapCoordinates;
//# sourceMappingURL=useMapCoordinates.js.map